module.exports = __webpack_public_path__ + "static/media/melillo-brain2.a5bf68f6.jpg";